export const RECOM_PROXY_BASE_PATH = '/api/recom';

export const RECOM_USER_DATA_KEY = {
	apiBaseUrl: 'recom_api_base_url',
	storeId: 'recom_store_id',
} as const;

export const RECOM_DEFAULT_STORE_ID = 'dpstreet';

export const RECOM_REQUEST_TIMEOUT_MS = 15_000;

export const RECOM_PARTNUMBERS_MAX = 20;

export const RECOM_ERROR_CODE = {
	validation: 'VALIDATION_ERROR',
	recommendationClient: 'RECOMMENDATION_CLIENT_ERROR',
	notFound: 'NOT_FOUND',
	internal: 'INTERNAL_SERVER_ERROR',
	proxy: 'RECOM_PROXY_ERROR',
	invalidResponse: 'RECOM_INVALID_RESPONSE',
} as const;

export type RecomErrorCode = typeof RECOM_ERROR_CODE[keyof typeof RECOM_ERROR_CODE];
